'use client'

import { createIcon } from '@chakra-ui/icons'

export default createIcon({
  displayName: 'Folder',
  viewBox: '0 0 20 20',
  d: 'M16.6667 4.99992H10L8.82502 3.82492C8.50835 3.50825 8.08335 3.33325 7.64169 3.33325H3.33335C2.41669 3.33325 1.67502 4.08325 1.67502 4.99992L1.66669 14.9999C1.66669 15.9166 2.41669 16.6666 3.33335 16.6666H16.6667C17.5834 16.6666 18.3334 15.9166 18.3334 14.9999V6.66659C18.3334 5.74992 17.5834 4.99992 16.6667 4.99992ZM15.8334 14.9999H4.16669C3.70835 14.9999 3.33335 14.6249 3.33335 14.1666V7.49992C3.33335 7.04159 3.70835 6.66659 4.16669 6.66659H15.8334C16.2917 6.66659 16.6667 7.04159 16.6667 7.49992V14.1666C16.6667 14.6249 16.2917 14.9999 15.8334 14.9999Z',
})
